import { provideAuthTokenFeature } from './auth-token/auth-token.reducer';
import { provideChatHeaderFeature } from './chat-header/chat-header.reducer';
import { provideLiveChatFeature } from './live-chat/live-chat.reducer';
import { provideMessagesFeature } from './messages/messages.reducer';
import { provideRecaptchaFeature } from './recaptcha/recaptcha.reducer';
import { provideSafeSendFeature } from './safe-send/safe-send.reducer';
import { provideTypingFeature } from './typing/typing.reducer';
import { provideUserInputFeature } from './user-input/user-input.reducer';
import { providePostEscalationCurationFeature } from './post-escalation-curation/post-escalation-curation.reducer';
import { provideWindowFeature } from './window/window.reducer';
import { provideSettingsFeature } from './settings/settings.reducers';
import { provideVaSessionFeature } from './va-session/va-session.reducer';
import { provideOverlayFeature } from './overlay-state/overlay.reducer';
import { provideEmailTranscriptFeature } from './email-transcript/email-transcript.reducer';
import { provideWindowMessagesFeature } from './window-messages/window-messages.reducer';
import { provideChatAdminFeature } from './chat-admin/chat-admin.reducer';
import { provideVaButtonFeature } from './va-button/va-button.reducer';
import { provideUserInfoFeature } from './user-info/user-info.reducer';
import { provideAutocompleteFeature } from './autocomplete/autocomplete.reducer';
import { providePendingActionFeature } from './pending-action/pending-action.reducer';
import { provideProactiveChatFeature } from './proactive-chat/proactive-chat.reducer';
import { provideAnalyticsFeature } from './analytics/analytics.reducer';

export function provideAppFeatures() {
  return [
    provideAuthTokenFeature(),
    provideChatHeaderFeature(),
    provideMessagesFeature(),
    provideLiveChatFeature(),
    provideRecaptchaFeature(),
    provideSafeSendFeature(),
    provideTypingFeature(),
    provideUserInputFeature(),
    providePostEscalationCurationFeature(),
    provideWindowFeature(),
    provideSettingsFeature(),
    provideVaSessionFeature(),
    provideOverlayFeature(),
    provideEmailTranscriptFeature(),
    provideWindowMessagesFeature(),
    provideChatAdminFeature(),
    provideVaButtonFeature(),
    provideUserInfoFeature(),
    provideAutocompleteFeature(),
    providePendingActionFeature(),
    provideProactiveChatFeature(),
    provideAnalyticsFeature(),
  ];
}
